// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Tk","title":"Uk","nav":"Vk","flexCell":"Wk","facetLink":"Xk"};